import type {
  OfflineSyncWireAcudiente,
  OfflineSyncWirePuntoEntrega,
  OfflineSyncWirePuntoParticipante,
  OfflineSyncWireRedencionBundle,
} from '../domain/offlineSyncPayload.ts';
import { normalizeDataUrlAttachment } from '../domain/syncWireAttachmentDataUrl.ts';

/** Acudiente document images ship as JPEG payloads on the ingest contract. */
export function normalizeWireAcudiente(a: OfflineSyncWireAcudiente): void {
  const jpeg = 'image/jpeg';
  a.documentoFrontal = normalizeDataUrlAttachment(a.documentoFrontal, jpeg);
  a.documentoReverso = normalizeDataUrlAttachment(a.documentoReverso, jpeg);
  a.documentoAutorizadoFrontal = normalizeDataUrlAttachment(a.documentoAutorizadoFrontal, jpeg);
  a.documentoAutorizadoReverso = normalizeDataUrlAttachment(a.documentoAutorizadoReverso, jpeg);
}

export function normalizeWirePuntoParticipante(p: OfflineSyncWirePuntoParticipante): void {
  p.firmaBase64 = normalizeDataUrlAttachment(p.firmaBase64, 'image/png');
  p.registroFotografico = normalizeDataUrlAttachment(p.registroFotografico, 'image/jpeg');
  if (p.acudiente) normalizeWireAcudiente(p.acudiente);
}

export function normalizeWirePuntoEntrega(m: OfflineSyncWirePuntoEntrega): void {
  m.informePdf = normalizeDataUrlAttachment(m.informePdf, 'application/pdf');
  for (const p of m.participantes) normalizeWirePuntoParticipante(p);
}

export function normalizeWireRedencionBundle(b: OfflineSyncWireRedencionBundle): void {
  b.header.informePdf = normalizeDataUrlAttachment(b.header.informePdf, 'application/pdf');
  for (const p of b.participantes) {
    p.firmaBase64 = normalizeDataUrlAttachment(p.firmaBase64, 'image/png');
    p.registroFotografico = normalizeDataUrlAttachment(p.registroFotografico, 'image/jpeg');
  }
}
